import { useState } from 'react';
import { ThemeProvider } from './context/ThemeContext';
import { Layout } from './components/Layout';
import { TextHash } from './components/TextHash';
import { FileHash } from './components/FileHash';
import { VerifyHash } from './components/VerifyHash';
import { BatchHash } from './components/BatchHash';

function App() {
  const [currentTab, setCurrentTab] = useState('text');

  return (
    <ThemeProvider>
      <Layout currentTab={currentTab} onTabChange={setCurrentTab}>
        {currentTab === 'text' && <TextHash />}
        {currentTab === 'file' && <FileHash />}
        {currentTab === 'verify' && <VerifyHash />}
        {currentTab === 'batch' && <BatchHash />}
      </Layout>
    </ThemeProvider>
  );
}

export default App;

